import { render, staticRenderFns } from "./BulkMenuUpdate.vue?vue&type=template&id=578723dc"
import script from "./BulkMenuUpdate.vue?vue&type=script&lang=js"
export * from "./BulkMenuUpdate.vue?vue&type=script&lang=js"
import style0 from "./BulkMenuUpdate.vue?vue&type=style&index=0&id=578723dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports